import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from './modules/material.module';
import { EhButtonComponent } from './components/button/eh-button.component';
import { TextboxComponent } from './components/textbox/textbox.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { SelectComponent } from './components/select/select.component';

// Lucide Icons
import { 
  CheckIcon, 
  ArrowRightIcon, 
  ArrowLeftIcon, 
  SendIcon, 
  PlusIcon, 
  DownloadIcon, 
  UploadIcon, 
  TrashIcon, 
  EditIcon, 
  SaveIcon, 
  SearchIcon, 
  XIcon, 
  ExternalLinkIcon, 
  RefreshCwIcon,
  Loader2Icon,
  LucideAngularModule,
  icons
} from 'lucide-angular';

@NgModule({
  declarations: [
    EhButtonComponent,
    TextboxComponent,
    DatepickerComponent,
    SelectComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    LucideAngularModule.pick(icons),
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    EhButtonComponent,
    TextboxComponent,
    DatepickerComponent,
    SelectComponent
  ]
})
export class LibraryModule { }
